import { ComponentProps } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Headline from 'modules/nps/components/Headline'
import { ReviewGrid } from './ReviewGrid'

type Props = {
  productName: string
  productIcon: ComponentProps<typeof Icon.Large>['icon']
  score?: number
}

export const SurveyThankYou = ({ productName, productIcon, score }: Props) => {
  return (
    <Box alignItems="center" justifyContent="center" textAlign="center" gap="s16">
      <Box gap="s16" maxWidth="s400">
        <Headline
          text={i18n.t('nps.survey_page.thank_you.title', { productName })}
          icon={productIcon}
        />
      </Box>

      {score && score >= 9 ? (
        <>
          <Box maxWidth="s600">
            <Text size="300">
              <Text size="300" weight="bold">
                {i18n.t('nps.survey_page.review.title')}
              </Text>
              {i18n.t('nps.survey_page.review.description')}
            </Text>
          </Box>
          <ReviewGrid />
        </>
      ) : (
        <Text size="200">{i18n.t('nps.survey_page.thank_you.description')}</Text>
      )}
    </Box>
  )
}
